export default __webpack_public_path__ + "static/media/AD_Logo_Primary.df26e6e4.svg";